import styled from "styled-components";
import { OverflowContainerVertical } from "./OverflowContainerVertical";
export const ScrollingListContainer = styled.div `
  ${OverflowContainerVertical}
  padding: 15px;
  border-radius: 10px;
  padding-bottom: 20px;
`;
